import AntdTable, { type ColumnType as AntdTableColumnType, type TableProps as AntdTableProps } from "antd/lib/table";
import { FC } from "react";

export type TableProps = AntdTableProps;
export type TableColumnType = AntdTableColumnType;

export const Table: FC<TableProps> & {
    Column: typeof AntdTable.Column;
    ColumnGroup: typeof AntdTable.ColumnGroup;
    Summary: typeof AntdTable.Summary;
    SummaryCell?: typeof AntdTable.Summary.Cell;
} = props => {
    return <AntdTable {...props} />;
};

Table.Column = AntdTable.Column;
Table.ColumnGroup = AntdTable.ColumnGroup;
Table.Summary = AntdTable.Summary;
Table.Summary.Cell = AntdTable.Summary.Cell;
